// TODO: move credentials to backend
export const clientId = '602971242403725328';
export const clientSecret = 'kaiybDmlMeDRA8un8tNXXxluxswscAEc';
export const apiUrl = 'https://discordapp.com/api';

// TODO: maybe just add this as a method of user
export function getAvatarUrl(userId, avatarId) {
    console.log(userId, avatarId)
    return `https://cdn.discordapp.com/avatars/${userId}/${avatarId}.png`;
}